/* istanbul ignore file */

import OneClick from 'infrastructure/security/authentication/OneClick/OneClick';

export default OneClick;
